import Vue from "vue";

import VueSkycons from "vue-skycons";
Vue.use(VueSkycons, {
  color: "#1e88e5"
});
